"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AmountInput = AmountInput;

var _numberInput = require("./number-input");

var _react = _interopRequireDefault(require("react"));

var _excluded = ["assetType", "changeCurrencyLink", "decimalPlaces"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Export `AmountInput` component.
 */
function AmountInput(props) {
  var assetType = props.assetType,
      changeCurrencyLink = props.changeCurrencyLink,
      decimalPlaces = props.decimalPlaces,
      rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_numberInput.NumberInput, _extends({
    decimalPlaces: decimalPlaces !== null && decimalPlaces !== void 0 ? decimalPlaces : 2,
    thousandsSeparator: assetType === 'fiat' ? ' ' : ''
  }, rest), changeCurrencyLink);
}